import { Card, Col, Row } from "antd";
import spacing from "../../../components/ui/spacingConfig";
import type { Constat } from "../../../types/constats";
import { UserForList } from "../../../types/user";

type Props = {
  constatData: Constat | undefined;
  pilote: UserForList;
  className?: string;
};

const CardPiloteGravityConstat: React.FC<Props> = ({
  constatData,
  pilote,
  className,
}) => {
  return (
    <Card title="Pilote et gravitÃ©" bordered={false} className={className}>
      <Row gutter={spacing.s}>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Pilote</p>
        </Col>
        <Col span={spacing.xs}>
          <p className="text-light-blue">{pilote.fullname}</p>
        </Col>
      </Row>
      <Row gutter={spacing.s}>
        <Col span={spacing.xs}>
          {" "}
          <p className="text-light-grey">GravitÃ©</p>
        </Col>
        <Col span={spacing.xs}>
          <p className="text-light-blue">{constatData?.gravity?.name}</p>
        </Col>
      </Row>
      <Row gutter={spacing.s}>
        <Col span={spacing.xs}>
          {" "}
          <p className="text-light-grey text-small-size">
            Analyse de cause nÃ©cessaire
          </p>
        </Col>
        <Col span={spacing.xs}>
          <p>{constatData?.needsCauseAnalysis ? "Oui" : "Non"}</p>
        </Col>
      </Row>
      <Row gutter={spacing.s}>
        <Col span={spacing.xs}>
          {" "}
          <p className="text-light-grey text-small-size">Actions nÃ©cessaires</p>
        </Col>
        <Col span={spacing.xs}>
          <p>{constatData?.needsActions ? "Oui" : "Non"}</p>
        </Col>
      </Row>
    </Card>
  );
};

export default CardPiloteGravityConstat;
